import React from 'react'
import './about.css'
import ME from './../../assets/profile.jpeg'
import {RiAwardFill} from 'react-icons/ri'
import {BsBuilding, BsFolderCheck} from 'react-icons/bs'

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>
        <div className='about__me'>
          <div className="about__me-image">
            {/* eslint-disable-next-line */}
            <img src={ME} alt="About Image"/>
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <RiAwardFill className='about__icon'/>
              <h5>Experience</h5>
              <small>1+ Years Working (including internships)</small>
            </article>
            <article className='about__card'>
              <BsBuilding className='about__icon'/>
              <h5>Top Tier Companies</h5>
              <small>Goldman Sachs</small>
            </article>
            <article className='about__card'>
              <BsFolderCheck className='about__icon'/>
              <h5>Projects</h5>
              <small>20+ Completed Projects</small>
            </article>
          </div>
          <p>
          I am currently pursuing a Bachelors's degree in both Computer Science and Biochemistry and I am looking to obtain a Masters's Degree in Machine Learning in the near future. 
          My current goals are to gain some experience in this industry and I know the best way to do this is to get hands-on experience in my field of study. 
          At this moment in time, I am searching for a position that will allow me to make use of my education and build my career.
          </p>
          <a href="#contact" className='btn btn-primary'>Contact Me</a>
        </div>
      </div>
    </section>
  )
}

export default About